import { render, staticRenderFns } from "./classPre.vue?vue&type=template&id=6021188d&scoped=true&"
import script from "./classPre.vue?vue&type=script&lang=js&"
export * from "./classPre.vue?vue&type=script&lang=js&"
import style0 from "./classPre.vue?vue&type=style&index=0&id=6021188d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021188d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
